export default "__VITE_ASSET__c514ca54__"